import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { Event, Visibility, VisibilityOff } from '@mui/icons-material';

import { moment } from '../../../../I18n';
import Alert from '../../../DesignSystem/Alert';

interface PublicationAlertProps {
  askToPublishAt?: string | null;
  publishedAt?: string | null;
  variant?: 'badge' | 'chip';
}

function PublicationAlert({
  askToPublishAt = null,
  publishedAt = null,
  variant = 'badge',
}: PublicationAlertProps) {
  let label = <FormattedMessage id="ARTICLE.NOT_PUBLISHED" />;
  let icon = <VisibilityOff />;

  if (publishedAt) {
    icon = <Visibility />;
    label = (
      <FormattedMessage
        id="POST_FORM.POST_PUBLISHED_AT"
        values={{
          date: <FormattedDate value={publishedAt} />,
          time: moment(publishedAt).format('LT'),
        }}
      />
    );
  } else if (askToPublishAt) {
    icon = <Event />;
    label = (
      <FormattedMessage
        id="ARTICLE.PUBLICATION_ALERT"
        values={{
          date: <FormattedDate value={askToPublishAt} />,
          time: moment(askToPublishAt).format('LT'),
        }}
      />
    );
  }

  if (variant === 'chip') {
    return <Chip icon={icon} label={label} size="small" />;
  }

  return (
    <Alert severity="info" icon={icon}>
      <Typography variant="body1">{label}</Typography>
    </Alert>
  );
}

PublicationAlert.propTypes = {
  askToPublishAt: PropTypes.string,
  publishedAt: PropTypes.string,
};

export default PublicationAlert;
